import { useCallback, useRef, useState } from 'react'

interface ToastState {
  id: number
  message: string
}

/**
 * Bitta vaqtinchalik xabarni ko'rsatish uchun yengil hook — global holat yoki provayder shart
 * emas, chunki hozircha faqat bitta sahifa (`Dashboard`) foydalanadi. Har chaqiruvda avvalgi
 * taymer bekor qilinadi, shunda tez-tez bosilganda xabar "yopishib" qolmaydi.
 */
export function useToast(durationMs = 2200) {
  const [toast, setToast] = useState<ToastState | null>(null)
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | undefined>(undefined)

  const showToast = useCallback(
    (message: string) => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current)
      const id = Date.now()
      setToast({ id, message })
      timeoutRef.current = setTimeout(() => {
        setToast((current) => (current?.id === id ? null : current))
      }, durationMs)
    },
    [durationMs],
  )

  return { toast, showToast }
}

/** Ekran pastida (tab bar ustida) chiqadigan vaqtinchalik xabar. */
export function ToastViewport({ message }: { message: string | null }) {
  return (
    <div
      aria-live="polite"
      className="pointer-events-none fixed inset-x-0 bottom-20 z-20 flex justify-center px-4 lg:bottom-6"
    >
      {message !== null && (
        <div className="pointer-events-auto rounded-button bg-app-text px-4 py-2 text-sm font-medium text-app-bg shadow-[0_4px_10px_rgba(0,0,0,.12)]">
          {message}
        </div>
      )}
    </div>
  )
}
